import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const SetOrderNumber: Handler = props => {
    props.dispatch({
        type: "Pages/OrderDetails/SetOrderNumber",
        orderNumber: "",
    });
};

export const chain = [SetOrderNumber];

const resetOrderNumber = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetOrderNumber");
export default resetOrderNumber;
